/*
  Wholesome Story: reading pages (assets/ws-legal.js)
  LAST UPDATED: 2026-10-08 PST - first version.

  WHERE IT RUNS: the policy pages (/policies/...) and every plain page (sections/main-page.liquid). Loaded with "defer".
  WHAT IT DOES, in the element with the class "ws-doc":
    1. Marks the lines that work as headings. The policy text has no heading tags: a heading is a short paragraph in capital letters,
       or a paragraph that is one bold phrase. The script adds a class and role="heading" to that paragraph. It never changes a word.
    2. Marks the "Last Updated ..." line, the "In Short: ..." lines, and empty paragraphs (they are hidden; they hold no text).
    3. Builds the "On this page" list from the headings, when the text has 4 or more. Desktop: the list in the side column.
       Phone: a closed list above the text, or, when the text has its own "TABLE OF CONTENTS" list, links on that list.
    4. Puts the last word of a policy title in the display type, as the other page titles have (the words stay the same).
  WITH NO SCRIPT the page is complete: all text is there, styled by assets/ws-legal.css. Only the lists in item 3 are missing.
  VERSION HISTORY: 2026-10-08 PST first version.
*/
(function () {
  'use strict';

  var MIN_HEADINGS = 4;
  var MAX_HEADING_CHARS = 90;

  function text(el) {
    return (el.textContent || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
  }
  function isCaps(t) {
    return /[A-Z]{2}/.test(t) && t === t.toUpperCase();
  }
  function key(t) {
    return t.toLowerCase().replace(/[^a-z0-9]+/g, '');
  }
  function nextReal(el) {
    var n = el.nextElementSibling;
    while (n && n.classList.contains('ws-doc__gap')) n = n.nextElementSibling;
    return n;
  }

  function titleKeyword(doc) {
    var h1 = doc.querySelector('.shopify-policy__title h1');
    if (!h1 || h1.children.length) return;
    var words = text(h1).split(' ');
    if (!words[0]) return;
    var last = words.pop();
    var span = document.createElement('span');
    span.className = 'ws-kw';
    span.textContent = last;
    h1.textContent = words.length ? words.join(' ') + ' ' : '';
    h1.appendChild(span);
  }

  function init(doc) {
    titleKeyword(doc);
    var root = doc.querySelector('.shopify-policy__body .rte, .ws-doc__body .rte');
    if (!root || doc.classList.contains('ws-doc--embed')) return;
    /* Some pages wrap all of the text in one <div>. Read the paragraphs inside it. */
    while (root.children.length === 1 && root.firstElementChild.tagName === 'DIV') root = root.firstElementChild;

    var heads = [];
    var contents = null;
    var items = Array.prototype.slice.call(root.children);

    items.forEach(function (el) {
      if (el.tagName === 'P' && !text(el) && !el.querySelector('img, iframe, video, input, button, svg')) el.classList.add('ws-doc__gap');
    });

    items.forEach(function (el, i) {
      var tag = el.tagName;
      var t = text(el);
      if (!t || el.classList.contains('ws-doc__gap')) return;
      if (tag === 'P') {
        if (/^last updated\b/i.test(t) && t.length < 60) { el.classList.add('ws-doc__updated'); return; }
        if (/^in short:/i.test(t)) { el.classList.add('ws-doc__short'); return; }
        /* A short line with no end mark, straight above an "In Short:" line: a smaller heading (privacy policy). Not in the list. */
        var after = nextReal(el);
        if (t.length <= 80 && !/[.;,:]$/.test(t) && !isCaps(t) && after && after.tagName === 'P' && /^in short:/i.test(text(after)) && !el.querySelector('a, img, br')) {
          el.classList.add('ws-doc__h', 'ws-doc__h--sub');
          el.setAttribute('role', 'heading');
          el.setAttribute('aria-level', '3');
          return;
        }
        var only = el.children.length === 1 ? el.firstElementChild : null;
        var boldOnly = !!only && /^(STRONG|B)$/.test(only.tagName) && text(only) === t;
        var caps = isCaps(t);
        if (t.length < 2 || t.length > MAX_HEADING_CHARS || /[.;,]$/.test(t) || !(caps || boldOnly) || el.querySelector('a, img, br')) return;
        if (/^(copyright|©)/i.test(t)) return; /* the copyright line at the end of the terms is in capitals; it is not a heading */
        el.classList.add('ws-doc__h');
        if (caps) el.classList.add('ws-doc__h--caps');
        el.setAttribute('role', 'heading');
        el.setAttribute('aria-level', '2');
        if (/^(table of )?contents$/i.test(t)) {
          var list = nextReal(el);
          if (list && /^(UL|OL)$/.test(list.tagName)) { contents = list; list.classList.add('ws-doc__contents'); }
          return;
        }
        if (i > 0) heads.push({ el: el, label: t });
      } else if (/^H[1-4]$/.test(tag)) {
        if (t.length > 110 || /\.$/.test(t)) { el.classList.add('ws-doc__note'); return; }
        if (isCaps(t)) el.classList.add('ws-doc__h--caps');
        heads.push({ el: el, label: t });
      }
    });

    if (heads.length < MIN_HEADINGS) return;

    var byKey = {};
    heads.forEach(function (h, i) {
      if (!h.el.id) h.el.id = 'ws-sec-' + (i + 1);
      if (!byKey[key(h.label)]) byKey[key(h.label)] = h.el.id;
    });

    function fill(ol) {
      heads.forEach(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.el.id;
        a.textContent = h.label;
        li.appendChild(a);
        ol.appendChild(li);
      });
    }

    /* Side column list (desktop). */
    var nav = doc.querySelector('[data-ws-doc-toc]');
    var navList = nav ? nav.querySelector('ol') : null;
    if (navList) { fill(navList); nav.hidden = false; }

    /* The text's own contents list: each entry becomes a link to its heading. */
    if (contents) {
      Array.prototype.forEach.call(contents.querySelectorAll('li'), function (li) {
        var id = byKey[key(text(li))];
        if (!id || li.querySelector('a')) return;
        var holder = li.querySelector('span') || li.querySelector('p') || li;
        var a = document.createElement('a');
        a.href = '#' + id;
        while (holder.firstChild) a.appendChild(holder.firstChild);
        holder.appendChild(a);
      });
    } else {
      /* No contents list in the text: a closed "On this page" list above it, for phones and tablets. */
      var card = doc.querySelector('.shopify-policy__body, .ws-doc__body');
      if (card) {
        var details = document.createElement('details');
        details.className = 'ws-doc__jump';
        var summary = document.createElement('summary');
        summary.textContent = 'On this page';
        var ol = document.createElement('ol');
        fill(ol);
        details.appendChild(summary);
        details.appendChild(ol);
        details.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a')) details.open = false; });
        card.insertBefore(details, card.firstChild);
      }
    }

    /* Mark the section the reader is in. */
    if (!navList || !('IntersectionObserver' in window)) return;
    var links = {};
    Array.prototype.forEach.call(navList.querySelectorAll('a'), function (a) { links[a.getAttribute('href').slice(1)] = a; });
    var current = null;
    function mark(id) {
      if (current === id || !links[id]) return;
      if (current && links[current]) links[current].removeAttribute('aria-current');
      current = id;
      var a = links[id];
      a.setAttribute('aria-current', 'true');
      /* Keep the marked entry in view inside the list. The page itself is not scrolled. */
      var top = a.offsetTop; /* .ws-doc__toc is position: relative, so this is the distance from the top of the list box */
      if (top < nav.scrollTop + 40 || top > nav.scrollTop + nav.clientHeight - 60) nav.scrollTop = Math.max(0, top - nav.clientHeight / 2);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) mark(en.target.id); });
    }, { rootMargin: '-100px 0px -70% 0px' });
    heads.forEach(function (h) { io.observe(h.el); });
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.ws-doc'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
